<template>
  <div class="product-component">
    <!-- 功能区 -->
    <div class="filter-container">
      <el-input
        v-model="searchParams.channel"
        placeholder="渠道"
        :disabled="isChannelDisabled"
        style="width: 200px; margin-right: 10px;"
      />
      <el-input
        v-model="searchParams.group"
        placeholder="产品组"
        :disabled="isGroupDisabled"
        style="width: 200px; margin-right: 10px;"
      />
      <el-button icon="el-icon-refresh"  type="info" @click="handleRefresh">刷新</el-button>
      <el-button type="warning" @click="clickProductTempAdd">
        模版导入产品
      </el-button>
    </div>

    <!-- 数据表格 -->
    <el-table
      :data="filteredProducts"
      stripe
      style="width: 100%; margin-top: 20px;"
      :resizable="false"
      v-loading="productsloading"
    >
      <el-table-column 
        prop="name" 
        label="名称" 
        width="200"
        show-overflow-tooltip
      />
      <el-table-column 
        prop="channel" 
        label="渠道" 
        width="200"
        show-overflow-tooltip
      />
      <el-table-column 
        prop="group" 
        label="产品组" 
        width="200"
        show-overflow-tooltip
      />
      <el-table-column 
        prop="desc" 
        label="备注" 
        width="460"
        show-overflow-tooltip
      >
      <template #default="{ row }">
        <div class="desc-column">
          <span class="desc-text">{{ row.desc || '无描述' }}</span>
          <el-button 
            type="text"
            size="mini"
            @click="showDescDialog(row)"
          >
            查看详情
          </el-button>
        </div>
      </template>
    </el-table-column>
        <el-table-column label="状态" width="280">
            <template #default="{ row }">
            <div class="status-container">
                <el-switch 
                :value="!row.configs.isoff"
                :loading="row.isUpdating"
                :disabled="row.isUpdating"
                active-color="#13ce66"
                inactive-color="#ff4949"
                @change="handleStatusChange(row)"
                />
                <span class="status-text" :class="{'online': !row.configs.isoff, 'offline': row.configs.isoff}">
                    {{ row.configs.isoff ? '已下架' : '上线中' }}
                </span>
                <el-button
                  size="mini"
                  type="info"
                  class="test-btn"
                  @click="handleTest(row)"
                >
                  测试
                </el-button>
                <el-button
                  size="mini"
                  type="info"
                  class="test-btn"
                  @click="handleCallbackTest(row)"
                >
                  回调
                </el-button>
            </div>
            </template>
        </el-table-column>
      <el-table-column 
        label="操作" 
        width="243"
      >
        <template #default="{ row }">
          <el-button size="mini" @click="handleEdit(row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(row)">删除</el-button>
          <el-button 
            size="mini" 
            type="success" 
            @click="handleCopy(row)"
            icon="el-icon-document-copy"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- Configs编辑对话框 -->
    <el-dialog
      :title="currentProduct.originalName ? '复制产品' : (currentProduct.name ? '编辑配置' : '新增配置')"
      :visible.sync="configDialogVisible"
      :modal="!isModalDialog"
      :close-on-click-modal="false"
      width="40%"
      top="3vh"
      custom-class="config-dialog"
    >
      <el-form label-position="top" class="compact-form">
        <div class="form-grid">
          <el-form-item label="名称" required class="compact-item">
            <el-input v-no-space v-model="currentProduct.name" :disabled="!currentProduct.originalName" placeholder="请输入新产品名称" size="small" />
          </el-form-item>
          <el-form-item label="Channel" class="compact-item">
            <el-input v-no-space v-model="currentProduct.channel" size="small" />
          </el-form-item>
          <el-form-item label="Group" class="compact-item">
            <el-input v-no-space v-model="currentProduct.group" size="small" :disabled="isGroupDisabled" />
          </el-form-item>
        </div>

        <el-form-item label="配置内容 (JSON格式)" required class="json-form-item">
            <div class="json-editor-toolbar">
            <el-button-group>
                <el-button 
                size="mini" 
                :type="isJsonEditable ? 'danger' : 'primary'"
                @click="toggleJsonEdit"
                >
                {{ isJsonEditable ? '取消编辑' : '编辑' }}
                </el-button>
                <el-button 
                size="mini" 
                type="success"
                @click="copyJsonContent"
                >
                复制
                </el-button>
            </el-button-group>
            </div>
            
            <div class="json-editor-container">
            <vue-json-editor
                v-if="editorKey" 
                :key="editorKey"
                v-model="jsonContent"
                :show-btns="false"
                :mode="isJsonEditable ? 'code' : 'view'"
                lang="zh"
                :show-mode-switcher="false"
                :onEditable="isJsonEditable"
                @json-change="onJsonChange"
                @has-error="onJsonError"
            />
            </div>
            <div v-if="jsonError" class="error-msg">JSON格式错误：{{ jsonError }}</div>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="configDialogVisible = false">取消</el-button>
        <el-button 
          size="small" 
          type="primary" 
          :disabled="jsonError != null"
          @click="handleConfigSubmit"
        >
          确定
        </el-button>
      </div>
    </el-dialog>

     <el-dialog
      title="模板导入"
      :visible.sync="templateDialogVisible"
      width="600px"
      :modal="!isModalDialog"
      :close-on-click-modal="false"
    >
      <el-form label-position="left" label-width="100px">
        <!-- 模板选择 -->
        <el-form-item label="模版选择">
          <el-select 
            v-model="selectedTemplate" 
            placeholder="请选择模板"
            style="width: 100%"
          >
            <el-option
              v-for="item in templateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <!-- 产品链接 -->
        <el-form-item label="产品链接">
            <div class="link-input-group">
            <el-input 
                v-model="productLink" 
                placeholder="请输入产品链接"
                class="link-input"
            />
            <el-button 
                type="primary" 
                class="parse-btn"
                @click="parseLink"
            >
                解析
            </el-button>
            </div>
        </el-form-item>

        <!-- 产品名称 -->
        <el-form-item label="产品名字">
          <el-input v-no-space v-model="productName" placeholder="请输入产品名称" />
        </el-form-item>

        <!-- 产品组名称 -->
        <el-form-item label="产品组">
          <el-input v-no-space v-model="productGroup" placeholder="请输入产品组" :disabled="isGroupDisabled" />
        </el-form-item>


        <!-- 解析结果展示 -->
        <el-form-item label="解析结果">
          <el-input
            type="textarea"
            :rows="4"
            readonly
            v-model="parseResult"
            placeholder="输入产品链接，点击解析"
          />
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="templateDialogVisible = false">取消</el-button>
        <el-button type="primary" :disabled="productTempAddBtnVaild" @click="handleTemplateImport">确认导入</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="currentDescProduct + '详情'"
      :visible.sync="descDialogVisible"
      :modal="!isModalDialog"
      :close-on-click-modal="false"
      width="50%"
      top="5vh"
    >
      <el-form label-position="top">
        <el-form-item>
          <el-input
            type="textarea"
            :rows="8"
            v-model="currentDesc"
            :readonly="!isDescEditable"
            resize="none"
            class="desc-textarea"
          />
        </el-form-item>
      </el-form>
      
      <div slot="footer">
        <el-button 
          type="primary"
          @click="toggleDescEdit"
        >
          {{ isDescEditable ? '保存' : '编辑' }}
        </el-button>
        <el-button @click="descDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="CallbackTestProduct + '回调测试'"
      :visible.sync="showCallbackDialog"
      :modal="!isModalDialog"
      :close-on-click-modal="false"
      width="70%"
      top="5vh"
    >
      <callback-search 
        ref="callbackSearchCom"
        :external-product="CallbackTestProduct"
      />
    </el-dialog>



  </div>
</template>

<script>
import vueJsonEditor from 'vue-json-editor'
import CallbackSearch from '@/components/CallbackSearch.vue'
import { ocpxDomain } from '../config/domain'

import {GetProductTemps, ParseProductTemp, AddProductByTemp, GetProducts, UpdateProduct, AddProduct, SetProductIsOff, DelProduct, SetProductDesc,GetProductTips} from '../api/index'

export default {
  components: {
    vueJsonEditor,
    CallbackSearch
  },
  name: 'ProductComponent',
  props: {
    externalChannel: {
      type: String,
      default: null
    },
    externalGroup: {
      type: String,
      default: null
    }
  },
  watch: {
    configDialogVisible(val) {
      if (!val) {
        this.jsonError = null
      }
      this.isJsonEditable = false
    },
    // 新增对props的监听
    externalChannel: {
      immediate: true,
      handler(newVal) {
        this.searchParams.channel = newVal || ''
      }
    },
    externalGroup: {
      immediate: true,
      handler(newVal) {
        this.searchParams.group = newVal || ''
      }
    }
  },
  data() {
    return {
      products: [],
      version:'',
      productsloading:false,
      searchParams: {
        channel: '',
        group: ''
      },
      configDialogVisible: false,
      currentProduct: this.getEmptyProduct(),
      jsonContent: {},
      jsonError: null,
      editorKey: 1,
      isJsonEditable: false,
      templateDialogVisible: false,
      templateOptions: [],
      selectedTemplate: '',
      productLink: '',
      productName: '',
      productGroup: '',
      parseResult: '输入产品链接，点击解析',
      productTempAddBtnVaild : true,
      descDialogVisible: false,
      currentDesc: '',
      currentDescProduct:'',
      isDescEditable: false,
      CallbackTestProduct:'',
      showCallbackDialog:false
    }
  },
  created(){
    this.fetchTemplates()
    this.getList()
  },
  computed: {
    filteredProducts() {
      return this.products.filter(item => {
        return (
          (!this.searchParams.channel || item.channel.includes(this.searchParams.channel)) &&
          (!this.searchParams.group ||  item.group === (this.searchParams.group))
        )
      })
    },
    // 新增计算属性
    isChannelDisabled() {
      return !!this.externalChannel
    },
    isGroupDisabled() {
      return !!this.externalGroup
    },
    isModalDialog(){
      return !!this.externalGroup
    }
  },
  methods: {

    getList(){
        this.productsloading = true
        GetProducts().then(res => {
            this.products = res.data
            this.productsloading = false
            this.version = res.version
        }).catch(error => {
            this.$message.error('数据获取失败:'+error)
            this.productsloading = false
        })
    },

    handleRefresh() {
      this.getList()
      this.$message.success("已刷新")
    },
    handleEdit(row) {
      this.currentProduct = JSON.parse(JSON.stringify(row))
      this.jsonContent = JSON.parse(JSON.stringify(row.configs))
      if(this.externalGroup && this.externalGroup != ""){
        this.currentProduct.group = this.externalGroup
      }
      this.configDialogVisible = true
    },
    onJsonChange(value) {
      try {
        this.jsonError = null
        this.currentProduct.configs = JSON.parse(JSON.stringify(value))
      } catch (e) {
        this.jsonError = e.message
      }
    },
    onJsonError(err) {
      this.jsonError = err
    },
    handleDelete(row) {
      this.$confirm('确认删除该记录？', '提示', {
        type: 'warning'
      }).then(() => {
        DelProduct({names:[row.name],version:this.version}).then(() => {
            this.$message.success("删除成功")
        }).catch(error => {
            this.$message.error('删除失败:'+error)
        }).finally(()=>{
          this.getList()
        })

      })
    },

    handleConfigSubmit() {
      if (!this.validateForm()) return

      // 判断是新增还是修改
      if (!this.currentProduct.originalName) {
        UpdateProduct(this.currentProduct.name, {...this.currentProduct,version:this.version}).then(() => {
            this.$message.success("保存成功")
            this.configDialogVisible = false
            this.getList()
        }).catch(() => {
            this.$message.error('产品信息更新失败')
        })
      } else {
        // 新增产品
        AddProduct(this.currentProduct).then(() => {
          this.$message.success('产品添加成功')
          this.configDialogVisible = false
          this.getList()
        }).catch(() => {
          this.$message.error('创建失败')
        })
      }
    },

    validateForm() {
      if (!this.currentProduct.name.trim()) {
        this.$message.error('名称不能为空')
        return false
      }
      // 检查名称是否已存在
      if (this.currentProduct.originalName &&this.products.some(p => p.name === this.currentProduct.name)) {
        this.$message.error('产品名称已存在')
        return false
      }
      if (this.jsonError) {
        this.$message.error('请修正JSON格式错误')
        return false
      }
      return true
    },

    getEmptyProduct() {
      return {
        name: '',
        desc: '',
        channel: '',
        group: '',
        configs: {
          adw2url: '',
          adwrequest: '',
          adwrequestmethod: 'GET',
          adwrequestparamstype: {},
          adwtoken: {
            algo: '',
            type: '',
            touper: false,
            exparams: '',
            params: [],
            secret: ''
          },
          tar2macro: {},
          tar2premac: {},
          tar2macrodefault: {},
          mustmacro: [],
          callbackpostparams: {
            ret: {
              mac: '',
              type: ''
            }
          },
          isoff: false
        }
      }
    },
    handleCopy(row) {
      // 复制产品数据
      const copiedProduct = JSON.parse(JSON.stringify(row))
      copiedProduct.originalName = row.name
      // 清空名称并标记为副本
      copiedProduct.name = ''
      copiedProduct.desc = new Date().toLocaleString();
    
      
      // 初始化编辑对话框
      this.currentProduct = copiedProduct
      this.jsonContent = JSON.parse(JSON.stringify(row.configs))
      this.configDialogVisible = true
      
      // 修改对话框标题
      this.$nextTick(() => {
        this.$message.info('请填写新的产品名称并确认保存')
      })
    },

    // 新增模板相关方法
    parseLink() {
        if(!this.productLink){
            this.$message.error('请输入产品链接')
            return
        }
        if(!this.selectedTemplate){
            this.$message.error('请选择模版')
            return
        }

        ParseProductTemp({temp:this.selectedTemplate, url:this.productLink}).then(res => {
            var retStr = "关键数据\n"
            var vaild = true
            for(var k in res.data){
                if(res.data[k] != "")
                {
                    retStr = retStr + k + "=" +res.data[k]+'\n'
                }else{
                    vaild = false
                    retStr = retStr + k + "(数据缺失)\n"
                }
            }
            this.productTempAddBtnVaild = !vaild
            this.parseResult = retStr

        }).catch(error => {
            this.$message.error('链接解析失败:'+error)

        })
        // 待实现的解析逻辑
        this.parseResult = '解析结果示例：\n- 产品ID: 123\n- 配置参数: {...}'
    },
    handleTemplateImport() {
      if (!this.productName) {
        this.$message.error('请输入产品名称')
        return
      }

      if(!this.productLink){
        this.$message.error('请输入产品链接')
        return
      }

      if(!this.selectedTemplate){
        this.$message.error('请选择模版')
        return
      }

      AddProductByTemp({temp:this.selectedTemplate, url:this.productLink, name:this.productName, group:this.productGroup}).then(() => {
        this.templateDialogVisible = false
        this.$message.success('模板导入成功')
        this.getList()
      }).catch(error => {
        this.$message.error('添加产品失败:'+error.error)
      })
      

    },

    async fetchTemplates() {
      GetProductTemps().then(res => {
        this.templateOptions = res.data.map(item => ({
          value: item,      
          label: item     
        }))
      }).catch(error => {
        this.$message.error('获取模版列表失败:'+error)
      })

    },

    clickProductTempAdd(){
        this.resetProductTempFrom()
        if(this.externalGroup && this.externalGroup != ""){
          this.productGroup = this.externalGroup
        }
        this.templateDialogVisible = true
    },

    resetProductTempFrom(){
      this.selectedTemplate = ''
      this.productLink = ''
      this.productName = ''
      this.productGroup = ''
      this.parseResult = ''
      this.productTempAddBtnVaild = true
    },

    toggleJsonEdit() {
      this.isJsonEditable = !this.isJsonEditable
      this.editorKey++

      if(this.jsonError != null || !this.isJsonEditable)
      {
        this.jsonContent = JSON.parse(
          JSON.stringify(this.currentProduct.configs)
        )
      }

    },

    copyJsonContent() {
      const content = JSON.stringify(this.jsonContent, null, 2)
      navigator.clipboard.writeText(content).then(() => {
        this.$message.success('已复制到剪贴板')
      }).catch(err => {
        console.error('复制失败:', err)
        this.$message.error('复制失败，请手动选择内容复制')
      })
    },

    async handleStatusChange(row) {
      try {
        // 锁定开关
        this.$set(row, 'isUpdating', true)

        // 调用后端接口（示例）
        await SetProductIsOff(row.name,{version:this.version})

      } catch  {
        this.$message.error("状态更新失败")
      } finally {
        this.$set(row, 'isUpdating', false)
        this.getList()
      }
    },
    // 新增方法
    showDescDialog(row) {
      this.currentDesc = row.desc || ''
      this.currentDescProduct = row.name
      this.isDescEditable = false
      this.descDialogVisible = true
    },

    toggleDescEdit() {
      if (this.isDescEditable) {
        
        SetProductDesc(this.currentDescProduct, {desc:this.currentDesc, version:this.version}).then(() => {
          // 此处可添加保存到后端的逻辑
          this.$message.success('描述已更新')
          this.getList()
          this.descDialogVisible = false
        }).catch(error => {
          this.$message.error('添加产品失败:'+error)
        })
      
      }
      this.isDescEditable = !this.isDescEditable
    },

     // 新增测试方法（功能暂留空）
    handleTest(row) {
      GetProductTips(row.name).then(res => {
          var url = ""
            for(var k in res.data){
              url = "http://"+ocpxDomain+"/test/comm/?product="+row.name+ "&" + res.data[k]
              break
            }
            window.open(url);
        }).catch(error => {
          this.$message.error('获取产品链接失败:'+error)
        })
      
    },
    
    // 打开回调窗口
    handleCallbackTest(row){
      this.showCallbackDialog = true
      this.CallbackTestProduct = row.name
    }
  
  }
}
</script>

<style scoped>
.filter-container {
  margin-bottom: 20px;
}
.el-table {
  margin-top: 20px;
}

/* 调整操作按钮间距 */
.el-button + .el-button {
  margin-left: 5px;
}

.compact-form {
  margin: -10px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  margin-bottom: 12px;
}

.compact-item {
  margin-bottom: 0 !important;
}

.compact-item ::v-deep .el-form-item__label {
  padding-bottom: 2px;
  font-size: 13px;
  line-height: 1.2;
}

.json-editor-container {
  height: 100%;
  min-height: 100px;
  border: 1px solid #dcdfe6;
  position: relative; /* 新增定位上下文 */
}

/* 完全重写编辑器样式 */
::v-deep .jsoneditor {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: none;
  display: flex;
  flex-direction: column;
}

::v-deep .jsoneditor-outer {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

::v-deep .jsoneditor-menu {
  flex-shrink: 0;
  height: 30px;
  background: #409EFF;
  border-bottom: 1px solid #409EFF;
}

::v-deep .jsoneditor-container {
  flex: 1;
  min-height: 0;
  overflow: auto;
  position: relative;
}

::v-deep .jsoneditor-contents {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

/*--------------- */
.json-editor-toolbar {
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;
}

.json-editor-toolbar .el-button-group {
  margin-right: 10px;
}

/* 调整编辑器容器高度 */
.json-editor-container {
  height: calc(80vh - 400px); /* 根据对话框高度动态调整 */
  min-height: 300px;
}

::v-deep .config-dialog {
  height: 80vh;
  min-height: 500px;
}

/* 禁用状态样式 */
::v-deep .jsoneditor-menu {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
}

::v-deep .jsoneditor {
  background-color: #fafafa;
}

::v-deep .jsoneditor textarea {
  cursor: not-allowed;
}

/*--------- */

::v-deep .ace_editor {
  height: 100% !important;
  min-height: 100% !important;
}

/* 强制隐藏模式切换按钮 */
::v-deep .jsoneditor-modes {
  display: none !important;
}

/* 调整工具栏布局 */
::v-deep .jsoneditor-menu > .jsoneditor-search {
  margin-left: 10px;
}

/* 新增样式 */
.el-form-item {
  margin-bottom: 18px;
}

.el-form-item__label {
  font-weight: 500;
}

.el-textarea__inner {
  background-color: #f5f7fa;
  color: #606266;
  font-family: monospace;
}

/* 链接输入组样式 */
.link-input-group {
  display: flex;
  gap: 8px; /* 按钮与输入框间距 */
}

.link-input {
  flex: 1; /* 输入框占满剩余空间 */
}

.parse-btn {
  flex-shrink: 0; /* 按钮不压缩 */
  width: 80px; /* 固定按钮宽度 */
}


.status-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.status-text {
  font-size: 14px;
  font-weight: 500;
}

.online {
  color: #67C23A;
}

.offline {
  color: #F56C6C;
}

/* 新增样式 */
.desc-column {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.desc-text {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 10px;
}

.desc-textarea ::v-deep .el-textarea__inner {
  font-size: 14px;
  line-height: 1.5;
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif;
  border: 1px solid #EBEEF5;
  border-radius: 4px;
  transition: all 0.3s;
}

.desc-textarea ::v-deep .el-textarea__inner:read-only {
  background-color: #f5f7fa;
  color: #909399;
  cursor: not-allowed;
}

.desc-textarea ::v-deep .el-textarea__inner:focus {
  border-color: #409EFF;
  box-shadow: 0 0 8px rgba(64, 158, 255, 0.2);
}

</style>